export default __webpack_public_path__ + "static/media/FeduManLogo.7655476a.png";